export default __webpack_public_path__ + "static/media/546.baa6fbc8.png";